export const listCampaignRoutes = {
  listCampaignsBaseRoute: '/dashboard/v2/list-campaign',
  listCampaignStagesBaseRoute: '/dashboard/v2/list-campaign-stage',
  listCampaignInfluencersBaseRoute: '/dashboard/v2/list-campaign-influencer',
  listCampaignTrackingBaseRoute: '/dashboard/v2/list-campaign/tracking',
  listCampaignAnalyticsBaseRoute: '/dashboard/v2/list-campaign/analytics',
};

export const ratnaTriggerBaseRoute = '/dashboard/v2/ratna-alert';

export const socialListeningRoutes = {
  base: '/dashboard/social',
  campaigns: '/dashboard/social/campaigns',
  addCampaign: '/dashboard/social/add',
  libraries: '/dashboard/social/libraries',
  libraryDetail: (id: string | number = ':id') => `/dashboard/social/libraries/${id}`,
  campaignDetail: (id: string | number = ':id') => `/dashboard/social/${id}`,
};

export const pulseSocialRoutes = {
  campaigns: '/dashboard/pulse',
  addCampaign: '/dashboard/pulse',
  campaignDetail: (_id: string | number = ':id') => '/dashboard/pulse',
};

export const getSocialBaseRoute = (): string =>
  pulseSocialRoutes.campaigns;

export const getSocialCampaignsRoute = (): string =>
  pulseSocialRoutes.campaigns;

export const getSocialAddCampaignRoute = (): string =>
  pulseSocialRoutes.campaigns;

export const getSocialCampaignDetailRoute = (id: string | number): string =>
  pulseSocialRoutes.campaignDetail(id);

export const libraryShareRoutes = {
  path: '/libraries/:ownerSlug/:librarySlug',
  libraryShare: (slug: string) => `/libraries/${slug}`,
};

export const reviewUsageRequestRoutes = {
  path: '/review-usage-requests',
  requestIdParam: 'request_id',
  href: (requestId: string) =>
    `/review-usage-requests?request_id=${encodeURIComponent(requestId)}`,
};
